export * from './IconCouch';
export { default as IconCouch } from './IconCouch';
